export default {
  namespaced: true,
  state: {
    id: 0,
    name: '',
		username: '',
    supplierName:{},
    supplierList:''
  },
  mutations: {
    updateId (state, id) {
      state.id = id
    },
    updateName (state, name) {
      state.name = name
    },
    updateSupplierName (state, supplierName) {
      state.supplierName = supplierName
    },
    updateSupplierList (state, supplierList) {
      state.supplierList = supplierList
    }
  },
}
